import { MoneySchema } from '@pf/contracts';
import { z } from 'zod';
/**
 * The customer's balances, as the participating website's own ledger holds them (SAD §3).
 *
 * PaymentFlow never sees these numbers and has no table that could produce them — "PF holds
 * records, not money" is the invariant this schema is downstream of. Every field here is the
 * website's, which is exactly why it belongs to the profile and not to `@pf/contracts`.
 */
export const CustomerBalanceSchema = z
    .object({
    /** Spendable right now. */
    available: MoneySchema,
    /**
     * Held against withdrawal requests that are live in PaymentFlow's pool — the funds lock
     * (SAD §3 D2). Not spendable, not yet gone.
     */
    locked: MoneySchema,
    /**
     * Owed to this customer for deposits PaymentFlow has CONFIRMED but the website has not yet
     * committed to its ledger. Zero in a healthy steady state; non-zero means a credit is in
     * flight (SAD §9's two-phase money ACK).
     */
    pending_credit: MoneySchema,
})
    .strict();
//# sourceMappingURL=balance.js.map